/* eslint-disable react/no-unknown-property */
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.13 ./public/models/InternalWallInsulation.glb --types 
*/

import React from 'react';
import { useGLTF } from '@react-three/drei';
import * as THREE from 'three';
import { GLTF } from 'three-stdlib';

type GLTFResult = GLTF & {
  nodes: {
    Cube011: THREE.Mesh;
    Cube200: THREE.Mesh;
  };
  materials: {
    ['wall.001']: THREE.MeshStandardMaterial;
    ['HIGHLIGHT.007']: THREE.MeshStandardMaterial;
  };
};

export function Model({ active, scale }: { active: boolean; scale: number }) {
  const { nodes, materials } = useGLTF('/models/InternalWallInsulation.glb') as GLTFResult;
  return (
    <group dispose={null} scale={scale}>
      <mesh
        geometry={nodes.Cube011.geometry}
        material={active ? materials['HIGHLIGHT.007'] : materials['wall.001']}
        position={[-0.859, 0.256, 0]}
      />
    </group>
  );
}

useGLTF.preload('/models/InternalWallInsulation.glb');
